"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DetailsPageLayout = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Link = require("../../elements/link/Link");
var _LoadingBlock = require("../../elements/loading-block/LoadingBlock");
var _detailsPageLayoutModule = _interopRequireDefault(require("./details-page-layout.module.scss"));
var _SectionPanel = require("../../components/section-panel/SectionPanel");
var DetailsPageLayout = function DetailsPageLayout(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
    children = _ref.children,
    title = _ref.title,
    _ref$goBackPosition = _ref.goBackPosition,
    goBackPosition = _ref$goBackPosition === void 0 ? 'right' : _ref$goBackPosition,
    goBackRoute = _ref.goBackRoute,
    goBackText = _ref.goBackText,
    isPageLoading = _ref.isPageLoading,
    className = _ref.className,
    panelSections = _ref.panelSections,
    panelClassName = _ref.panelClassName;
  var renderGoBackRoute = function renderGoBackRoute() {
    if (!goBackRoute) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement(_Link.Link, {
      href: goBackRoute,
      className: (0, _classnames.default)(_detailsPageLayoutModule.default['details-page-layout__link'], _detailsPageLayoutModule.default["details-page-layout__link--".concat(goBackPosition)])
    }, goBackText);
  };
  var shouldDisplayPanel = panelSections && panelSections.length > 0;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_detailsPageLayoutModule.default['details-page-layout__container'], className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _detailsPageLayoutModule.default['details-page-layout__main-content']
  }, breadcrumbs && /*#__PURE__*/_react.default.createElement("div", null, breadcrumbs), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "link-container",
    className: (0, _classnames.default)(_detailsPageLayoutModule.default['details-page-layout__header'], _detailsPageLayoutModule.default["details-page-layout__header-link--".concat(goBackPosition)])
  }, !isPageLoading ? /*#__PURE__*/_react.default.createElement("h1", {
    className: _detailsPageLayoutModule.default['details-page-layout__title']
  }, title) : /*#__PURE__*/_react.default.createElement(_LoadingBlock.LoadingBlock, {
    className: _detailsPageLayoutModule.default['details-page-layout__title--loading']
  }), renderGoBackRoute()), /*#__PURE__*/_react.default.createElement("div", {
    className: _detailsPageLayoutModule.default['details-page-layout__content']
  }, children)), shouldDisplayPanel && /*#__PURE__*/_react.default.createElement(_SectionPanel.SectionPanel, {
    sections: panelSections,
    className: panelClassName
  }));
};
exports.DetailsPageLayout = DetailsPageLayout;